import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { INotificationCardNotification } from '../components/organism/NotificationCard';

interface IRedirectState {
  essay_performance: boolean;
  essay_theme: boolean;
  essay_my_essays: boolean;
  simulation_enem: boolean;
  simulation: boolean;
  live: boolean;
  live_favs: boolean;
  live_monitoring: boolean;
  live_challenge: boolean;
  my_favorites: boolean;
  my_favorites_content: boolean;
  profile: boolean;
  community: boolean;
  discipline_modules: boolean;
  course_regionals: boolean;
  my_plans: boolean;
  mural: boolean;
  events: boolean;
  notifications: INotificationCardNotification[];
  setEssay_performance: (checking: boolean) => void;
  setEssay_theme: (checking: boolean) => void;
  setEssay_my_essays: (checking: boolean) => void;
  setSimulation_enem: (checking: boolean) => void;
  setSimulation: (checking: boolean) => void;
  setLive: (checking: boolean) => void;
  setLive_favs: (checking: boolean) => void;
  setLive_monitoring: (checking: boolean) => void;
  setLive_challenge: (checking: boolean) => void;
  setMy_favorites: (checking: boolean) => void;
  setMy_favorites_content: (checking: boolean) => void;
  setProfile: (checking: boolean) => void;
  setCommunity: (checking: boolean) => void;
  setDisciplines_modules: (checking: boolean) => void;
  setCourse_regionals: (checking: boolean) => void;
  setMy_plans: (checking: boolean) => void;
  setMural: (checking: boolean) => void;
  setEvents: (checking: boolean) => void;
  setNotifications: (notifications: INotificationCardNotification[]) => void;
}

export const useRedirectStore = create<IRedirectState>()(
  persist(
    (set) => ({
      essay_performance: false,
      essay_theme: false,
      essay_my_essays: false,
      simulation_enem: false,
      simulation: false,
      live: false,
      live_favs: false,
      live_monitoring: false,
      live_challenge: false,
      my_favorites: false,
      my_favorites_content: false,
      profile: false,
      community: false,
      discipline_modules: false,
      course_regionals: false,
      my_plans: false,
      mural: false,
      events: false,
      notifications: [],
      setEssay_performance: (checking: boolean) =>
        set({ essay_performance: checking }),
      setEssay_theme: (checking: boolean) => set({ essay_theme: checking }),
      setEssay_my_essays: (checking: boolean) =>
        set({ essay_my_essays: checking }),
      setSimulation_enem: (checking: boolean) =>
        set({ simulation_enem: checking }),
      setSimulation: (checking: boolean) => set({ simulation: checking }),
      setLive: (checking: boolean) => set({ live: checking }),
      setLive_favs: (checking: boolean) => set({ live_favs: checking }),
      setLive_monitoring: (checking: boolean) =>
        set({ live_monitoring: checking }),
      setLive_challenge: (checking: boolean) =>
        set({ live_challenge: checking }),
      setMy_favorites: (checking: boolean) => set({ my_favorites: checking }),
      setMy_favorites_content: (checking: boolean) =>
        set({ my_favorites_content: checking }),
      setProfile: (checking: boolean) => set({ profile: checking }),
      setCommunity: (checking: boolean) => set({ community: checking }),
      setDisciplines_modules: (checking: boolean) =>
        set({ discipline_modules: checking }),
      setCourse_regionals: (checking: boolean) =>
        set({ course_regionals: checking }),
      setMy_plans: (checking: boolean) => set({ my_plans: checking }),
      setMural: (checking: boolean) => set({ mural: checking }),
      setEvents: (checking: boolean) => set({ events: checking }),
      setNotifications: (notifications: INotificationCardNotification[]) =>
        set({ notifications: notifications })
    }),
    {
      name: 'redirect-storage',
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) => !['notifications'].includes(key)
          )
        ),
    }
  )
);
